const midiInstrumentNames = {
  0: 'Acoustic Grand Piano',
  1: 'Bright Acoustic Piano',
  2: 'Electric Grand Piano',
  3: 'Honky-tonk Piano',
  4: 'Electric Piano 1',
  5: 'Electric Piano 2',
  6: 'Harpsichord',
  7: 'Clavinet',
  8: 'Celesta',
  9: 'Glockenspiel',
  10: 'Music Box',
  11: 'Vibraphone',
  12: 'Marimba',
  13: 'Xylophone',
  14: 'Tubular Bells',
  15: 'Dulcimer',
  16: 'Drawbar Organ',
  17: 'Percussive Organ',
  18: 'Rock Organ',
  19: 'Church Organ',
  20: 'Reed Organ',
  21: 'Accordion',
  22: 'Harmonica',
  23: 'Tango Accordion',
  24: 'Acoustic Guitar (nylon)',
  25: 'Acoustic Guitar (steel)',
  26: 'Electric Guitar (jazz)',
  27: 'Electric Guitar (clean)',
  28: 'Electric Guitar (muted)',
  29: 'Overdriven Guitar',
  30: 'Distortion Guitar',
  31: 'Guitar Harmonics',
  32: 'Acoustic Bass',
  33: 'Electric Bass (finger)',
  34: 'Electric Bass (pick)',
  35: 'Fretless Bass',
  36: 'Slap Bass 1',
  37: 'Slap Bass 2',
  38: 'Synth Bass 1',
  39: 'Synth Bass 2',
  40: 'Violin',
  41: 'Viola',
  42: 'Cello',
  43: 'Contrabass',
  44: 'Tremolo Strings',
  45: 'Pizzicato Strings',
  46: 'Orchestral Harp',
  47: 'Timpani',
  48: 'String Ensemble 1',
  49: 'String Ensemble 2',
  50: 'Synth Strings 1',
  51: 'Synth Strings 2',
  52: 'Choir Aahs',
  53: 'Voice Oohs',
  54: 'Synth Choir',
  55: 'Orchestra Hit',
  56: 'Trumpet',
  57: 'Trombone',
  58: 'Tuba',
  59: 'Muted Trumpet',
  60: 'French Horn',
  61: 'Brass Section',
  62: 'Synth Brass 1',
  63: 'Synth Brass 2',
  64: 'Soprano Sax',
  65: 'Alto Sax',
  66: 'Tenor Sax',
  67: 'Baritone Sax',
  68: 'Oboe',
  69: 'English Horn',
  70: 'Bassoon',
  71: 'Clarinet',
  72: 'Piccolo',
  73: 'Flute',
  74: 'Recorder',
  75: 'Pan Flute',
  76: 'Blown Bottle',
  77: 'Shakuhachi',
  78: 'Lead 1 (square)',
  79: 'Lead 2 (sawtooth)',
  80: 'Lead 3 (calliope)',
  81: 'Lead 4 (chiff)',
  82: 'Lead 5 (charang)',
  83: 'Lead 6 (voice)',
  84: 'Lead 7 (fifths)',
  85: 'Lead 8 (bass + lead)',
  86: 'Pad 1 (new age)',
  87: 'Pad 2 (warm)',
  88: 'Pad 3 (polysynth)',
  89: 'Pad 4 (choir)',
  90: 'Pad 5 (bowed)',
  91: 'Pad 6 (metallic)',
  92: 'Pad 7 (halo)',
  93: 'Pad 8 (sweep)',
  94: 'FX 1 (rain)',
  95: 'FX 2 (soundtrack)',
  96: 'FX 3 (crystal)',
  97: 'FX 4 (atmosphere)',
  98: 'FX 5 (brightness)',
  99: 'FX 6 (goblins)',
  100: 'FX 7 (echoes)',
  101: 'FX 8 (sci-fi)',
  102: 'Sitar',
  103: 'Banjo',
  104: 'Shamisen',
  105: 'Koto',
  106: 'Kalimba',
  107: 'Bagpipe',
  108: 'Fiddle',
  109: 'Shanai',
  110: 'Tinkle Bell',
  111: 'Agogo',
  112: 'Steel Drums',
  113: 'Woodblock',
  114: 'Taiko Drum',
  115: 'Melodic Tom',
  116: 'Synth Drum',
  117: 'Reverse Cymbal',
  118: 'Guitar Fret Noise',
  119: 'Breath Noise',
  120: 'Seashore',
  121: 'Bird Tweet',
  122: 'Telephone Ring',
  123: 'Helicopter',
  124: 'Applause',
  125: 'Gunshot'
};
export default function lookupInstrument(id) {
    return midiInstrumentNames[id] ? midiInstrumentNames[id].toLowerCase().replaceAll('(','').replaceAll(')','').replaceAll(' ','_').trim() : ''
}
